// ordergroove shadow DOM
(() => {
  const STYLE_ATTR = "data-og-shadow-style";

  const OG_SELECT_CONTAINER_CSS = `
      og-select { width: 100%; }
    `;

  const OG_SELECT_CSS = `
      select {
        font-size: 1.4rem !important;
        line-height: 2rem !important;
        font-family: var(--font-medium-family) !important;
        font-weight: 500 !important;
        color: var(--grayscale-600) !important;
      }
      span { right: 16px !important; }
    `;

  const addStyle = (shadowRoot, css) => {
    if (!shadowRoot) return false;
    if (shadowRoot.querySelector(`style[${STYLE_ATTR}]`)) return true;

    const el = document.createElement("style");
    el.setAttribute(STYLE_ATTR, "");
    el.textContent = css;
    shadowRoot.appendChild(el);
    return true;
  };

  const applyStyles = () => {
    document.querySelectorAll("og-select-frequency").forEach((host) => {
      const hostShadowRoot = host.shadowRoot;
      if (!hostShadowRoot) return;

      addStyle(hostShadowRoot, OG_SELECT_CONTAINER_CSS);

      const selectShadowRoot =
        hostShadowRoot.querySelector("og-select")?.shadowRoot;
      if (!selectShadowRoot) return;

      addStyle(selectShadowRoot, OG_SELECT_CSS);
    });
  };

  const watch = () => {
    let queued = false;
    const queueApply = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        applyStyles();
      });
    };

    const root =
      document.querySelector(
        '[id*="ordergroove_subscriptions_pdp_offer_block"]'
      ) || document.body;

    const containsOgSelect = (el) =>
      el.matches?.("og-offer, og-select-frequency, og-select") ||
      el.querySelector?.("og-select-frequency");

    const onAddedNodes = (mutations) => {
      for (const mutation of mutations) {
        for (const addedNode of mutation.addedNodes) {
          if (addedNode.nodeType !== 1) continue;
          if (!containsOgSelect(addedNode)) continue;

          queueApply();
          return;
        }
      }
    };

    const domObserver = new MutationObserver(onAddedNodes);
    domObserver.observe(root, { childList: true, subtree: true });

    applyStyles();

    setTimeout(() => domObserver.disconnect(), 3000);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch, { once: true });
  } else {
    watch();
  }
})();
